/* unplugin-vue-components disabled */import { render } from "./icon-like.vue?vue&type=template&id=120f3aeb"
import script from "./icon-like.vue?vue&type=script&lang=js"
export * from "./icon-like.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/icon-like.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "120f3aeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('120f3aeb', __exports__)) {
    api.reload('120f3aeb', __exports__)
  }
  
  module.hot.accept("./icon-like.vue?vue&type=template&id=120f3aeb", () => {
    api.rerender('120f3aeb', render)
  })

}


export default __exports__